export default {"src":"/_next/static/media/logo-text.f8a9d8b5.svg","height":36,"width":113,"blurWidth":0,"blurHeight":0};